import { css } from '@emotion/react'

export default css`
    .ant-avatar.ant-avatar-square {
        border-radius: 25%;
    }
`
